const SIZES = ['180w', '240w', '480w', '640w'];
const PNG_FILE_FORMAT = '.png';

/**
 * Takes a full image url string and creates a srcSet string with the sizes above.
 * Example of a full image url: https://www.image-provider.com/under/some/dir/happy-cat.jpg
 *
 * @param {string} source - url string of the original image
 *
 * @param {boolean} forceJPG - forces .jpg file format. Some resources are being uploaded as .png, and the script that creates the different sizes of the images
 * outputs the .png images as .jpg. So the original will be avilalble as .png but if you want to use srcSets with different sizes you need to force .jpg in the
 * filename.
 *
 * @returns {string} Returns the srcSet string:
 * 'https://www.image-provider.com/under/some/dir/180w/happy-cat.jpg 180w, https://www.image-provider.com/under/some/dir/240w/happy-cat.jpg 240w, ..etc'
 */

export default function generateSrcSet(source, forceJPG) {
	const lastSlash = source.lastIndexOf('/');
	const pathToFileName = source.substring(0, lastSlash);
	const endOfFileName = source.substring(lastSlash + 1);
	// If there are spaces in the filename, replace them with '%20'
	const fileNameTrimmed = encodeURIComponent(endOfFileName.trim());
	const lastDot = fileNameTrimmed.lastIndexOf('.');
	const fileFormat = fileNameTrimmed.substring(lastDot, fileNameTrimmed.length);

	let fileNameWithJpg = null;
	if (forceJPG && fileFormat === PNG_FILE_FORMAT) {
		const sliceFileFormat = fileNameTrimmed.slice(0, lastDot);
		fileNameWithJpg = `${sliceFileFormat}.jpg`;
	}

	const srcSet = SIZES.reduce((acc, size) => {
		const withSize = `/${size}/${fileNameWithJpg || fileNameTrimmed} ${size},`;
		const fullFile = `${pathToFileName}${withSize}`;
		return `${acc}${fullFile} `;
	}, '');

	const removeLastSpaceAndComma = srcSet.trim().slice(0, -1);
	return removeLastSpaceAndComma;
}
